import React from 'react'
import styles from '../Select.module.scss'
import { LoadingBar } from 'components/Loading'
import VirtualList from 'components/VirtualList'

const SelectVirtualList = ({ selectProps, children, options, maxHeight, ...rest }) => {
	const { noOptionsMessage, getOptionValue, value } = selectProps
	const {
		loadNextPage,
		hasNextPage,
		loadPreviousPage,
		hasPreviousPage,
		loading,
		error
	} = selectProps.remoteResult
	const itemSize = 36

	const itemRenderer = ({ index, style }) => (
		<div style={style} className='select-virtualized-option'>{children[index]}</div>
	)

	const noItemsRenderer = () => (
		<div className={`${styles['no-options']} ${'select-virtualized-option'}`}>{noOptionsMessage()}</div>
	)

	const selectedOptionValue = value ? getOptionValue(value) : null

	return(
		<>
			<VirtualList
				itemRenderer={itemRenderer}
				itemCount={options.length}
				itemSize={itemSize}
				width={300}
				style={{ maxWidth: '100%' }}
				height={options.length * itemSize > maxHeight ? maxHeight : (options.length * itemSize || 40)}
				noItemsRenderer={noItemsRenderer}
				dataLoadOffset={10}
				startFromIndex={options.findIndex(opt => getOptionValue(opt) === selectedOptionValue)}
				loading={loading}
				error={error}
				hasNextPage={hasNextPage}
				hasPreviousPage={hasPreviousPage}
				loadNextPage={loadNextPage}
				loadPreviousPage={loadPreviousPage}
				disableAutoSizer={true}
			/>
			{loading && <LoadingBar />}
		</>
	)
}


export default SelectVirtualList
